import { observer } from 'mobx-react-lite'
import { type CallCenterJobViewModel } from './CallCenterJobViewModel'
import { CallCenterJobCreationFormContainer } from './CallCenterJobCreationForm/CallCenterJobCreationFormContainer'
import { JobSection } from '@/features/call-center/JobSection'
import { links } from '@/utils/link'

export interface JobSectionContainerProps {
  vm: CallCenterJobViewModel
}

export const JobSectionContainer = observer(function JobSectionContainer({
  vm,
}: JobSectionContainerProps) {
  const jobCreation = vm.jobCreation

  return (
    <JobSection
      isInitializing={vm.initializeJob.pending || vm.openExistingJob.pending}
      hasActiveClient={vm.hasActiveClient}
      hasJobCreation={!!jobCreation}
      contact={{
        fullName: vm.activeMember?.displayName ?? '',
        email: vm.activeMember?.email ?? '',
        phone: vm.activeMember?.phone ?? '',
        workspace: vm.activeMember?.workspace.name ?? '',
      }}
      requiredQuestionsAmount={vm.requiredQuestionsAmount}
      form={
        jobCreation && (
          <CallCenterJobCreationFormContainer
            vm={vm}
            jobCreation={jobCreation}
          />
        )
      }
      onPrevious={vm.goToCustomerLookup}
      canProceed={!!vm.isReady}
      next={
        jobCreation?.jobWasCreated
          ? links.callCenterJobCheckout(jobCreation.job.id)
          : undefined
      }
    />
  )
})
